/** Sage empnum / jobnum: whole number greater than 0. */
export function isWholeSageNumber(value: string): boolean {
  return /^[1-9]\d*$/.test(value.trim())
}

/**
 * Sage cstcde Numeric(12,3): a number greater than 0 with up to 3 decimals.
 * Examples: 2120, 2120.5, 2120.500. Hyphenated codes like 01-100 are invalid.
 */
export function isSageCostCode(value: string): boolean {
  const trimmed = value.trim()
  if (!/^(?:0|[1-9]\d*)(?:\.\d{1,3})?$/.test(trimmed)) return false
  return Number(trimmed) > 0
}

export function parseWholeSageNumber(value: string): number | null {
  const trimmed = value.trim()
  if (!isWholeSageNumber(trimmed)) return null
  return Number(trimmed)
}

export function parseSageCostCode(value: string): number | null {
  const trimmed = value.trim()
  if (!isSageCostCode(trimmed)) return null
  return Number(trimmed)
}

export function displayJobSiteCode(site: {
  jobNumber?: string | number | null
  shortName?: string | null
  sageRecnum?: string | null
}): string {
  if (site.jobNumber != null && String(site.jobNumber).trim()) return String(site.jobNumber)
  if (site.shortName != null && String(site.shortName).trim()) return String(site.shortName)
  return site.sageRecnum ? String(site.sageRecnum) : ""
}

export function displayEmployeeName(row: {
  firstName?: string | null
  lastName?: string | null
  employeeNum?: number | null
  id?: number
}): string {
  const combined = [row.firstName, row.lastName].filter(Boolean).join(" ").trim()
  if (combined) return combined
  if (row.employeeNum != null) return `Employee ${row.employeeNum}`
  return row.id != null ? `Employee ${row.id}` : ""
}

export function displayJobCode(code: string | number | null | undefined): string {
  if (code == null) return ""
  return String(code)
}
